<template>
  <div class="login horizontal layout center fit center-justified">
    <i class="fas fa-spinner fa-spin" />
  </div>
</template>

<script>
import util from '@/util'
import AuthApi from '@/api/auth'
import config from '@/config'
import { mapActions } from 'vuex'
import constant from '@/constant'
import * as Sentry from '@sentry/vue'

export default {
  data() {
    return {

    }
  },
  async mounted() {
    const code = util.getParamValue('code')
    if (!code) {
      Sentry.captureException(new Error('No token'))
      this.$router.replace({ name: 'home' })
      return
    }
    const {
      GOOGLE_SIGNIN_REDIRECT,
      GOOGLE_SIGNIN_SOURCE,
    } = constant.storageKeys
    const googleSource = window.localStorage.getItem(GOOGLE_SIGNIN_SOURCE)
    const firstPage = util.getCookie('ahaFirstPage')

    let token
    let user
    try {
      const resLogin = await AuthApi.loginWithGoogleForAudience({
        code,
        redirectUri: config.googleRedirect,
        source: googleSource,
        firstPage,
      })
      token = resLogin.token
      user = resLogin.user
    } catch (e) {
      const redirect = window.localStorage.getItem(GOOGLE_SIGNIN_SOURCE)
      if (redirect) {
        window.location.href = redirect
        return
      }
      this.$router.replace({ name: 'home' })
      return
    }
    util.removeFirstPageCookie()
    util.setCookieToken(token)
    if (user && user.id) {
      await this.setCurrentUserAction(user)
      window.localStorage.setItem('show-toasted-login', true)
    }

    util.ga4Track('audience_login', {
      method: 'with google',
      eventLabel: user.source,
    })

    const redirect = window.localStorage.getItem(GOOGLE_SIGNIN_REDIRECT)
    if (redirect) {
      window.localStorage.removeItem(GOOGLE_SIGNIN_REDIRECT)
      window.location.href = redirect
      return
    }
    this.$router.replace({ name: 'home' })
  },
  methods: {
    ...mapActions(['setCurrentUserAction']),
  },
}
</script>

<style scoped>
</style>
